<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div v-if="bot.type === AloAi.TYPE_TEXT">
                    <h3 class="text-dark">
                        <i class="el-icon-refresh-right"></i>
                        <span>Actions</span>
                    </h3>

                    <el-form-item>
                        <div class="form-label d-flex">
                            <el-switch
                                class="mr-2 align-self-center"
                                v-model="bot.follow_up_enabled"
                                active-color="#00BF50"
                                data-testid="aloai-follow-up-switch"
                            />
                            <div>
                                <h6 class="mb-1 mt-1">Enable Follow Up</h6>
                                <small>
                                    Automate follow-ups with unresponsive contacts by setting the number and timing of follow-up attempts. This helps maintain engagement without manual intervention.
                                </small>
                            </div>
                        </div>

                        <!-- Follow Up Frequency -->
                        <div
                            v-show="bot.follow_up_enabled"
                            class="mt-3"
                        >
                            <div class="form-label">
                                <h6 class="mb-1">Follow-up Attempts</h6>
                                <small>
                                    Choose how many times the agent will attempt to re-engage with unresponsive contacts. More attempts increase engagement chances but may become intrusive.
                                </small>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <el-form-item class="no-border">
                                        <el-input
                                            type="number"
                                            class="w-100"
                                            v-model="bot.follow_up_frequency"
                                            :disabled="!bot.follow_up_enabled"
                                            :max="100"
                                            :min="1"
                                            @input="handleFollowUpFrequencyInput"
                                            data-testid="aloai-follow-up-frequency-input"
                                        >
                                            <template slot="append">
                                                Attempt<span v-if="bot.follow_up_frequency != 1">s</span>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>

                        <!-- Follow Up Delay -->
                        <div
                            v-show="bot.follow_up_enabled"
                            class="mt-3"
                        >
                            <div class="form-label">
                                <h6 class="mb-1">Follow-up Delay</h6>
                                <small>
                                    Set the time between follow-up attempts. Shorter delays for urgent matters, longer delays to avoid overwhelming contacts.
                                </small>
                            </div>
                            <DurationPicker
                                :current_seconds="bot.follow_up_delay"
                                @update_seconds="onUpdateFollowUpDelay"
                                data-testid="aloai-follow-up-delay-picker"
                            />
                        </div>
                    </el-form-item>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as AloAi from '../../../../constants/aloai'
import DurationPicker from '../duration-picker'

export default {
    name: 'actions-tab',

    components: {
        DurationPicker
    },

    props: {
        bot: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            AloAi
        }
    },

    methods: {
        onUpdateFollowUpDelay(seconds) {
            this.bot.follow_up_delay = seconds
        },

        handleFollowUpFrequencyInput(value) {
            // The element UI component handles the input as a string, so we need to parse it to an integer
            this.bot.follow_up_frequency = parseInt(value) || 0
        }
    }
}
</script>
